export enum QuestionTones {
  ENGAGING = "ENGAGING",
  FORMAL = "FORMAL",
  FRIENDLY = "FRIENDLY",
}
